/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { AddressFormProps, CreateCustomerAddressResponse } from '@/auth/types';
import { fetchGraphQl } from '../fetch-graphql';
import { CREATE_CUSTOMER_ADDRESS } from './graphql/createCustomerAddress.graphql';
import { handleNetworkError } from '@/auth/lib/network-error';
import { handleFetchError } from '@/auth/lib/fetch-error';

export const createCustomerAddress = async (
  address: AddressFormProps
): Promise<string> => {
  return await fetchGraphQl(CREATE_CUSTOMER_ADDRESS, {
    method: 'POST',
    variables: {
      input: address,
    },
  })
    .then((response: CreateCustomerAddressResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return response.data.createCustomerAddress.firstname || '';
    })
    .catch(handleNetworkError);
};
